module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_400_Medium.6ed4ed5.woff2";